module.exports = __webpack_public_path__ + "static/media/tone4_ok.1dfe8df4.svg";